// Display box ratio. el-api resizes by width only, so the crop lives here.
const IMAGE_RATIO_W = 4;
const IMAGE_RATIO_H = 3;

export const ASPECT_PERCENT = (IMAGE_RATIO_H / IMAGE_RATIO_W) * 100;

// Wider 3:2 box for the featured hero image.
export const FEATURED_ASPECT_PERCENT = (2 / 3) * 100;

// Fixed display sizes for image spots that aren't full-width AssetImage boxes,
// kept here so a redesign can adjust them without hunting inline styles.
export const DETAIL_IMAGE_WIDTH = '200px'; // buy-now contact panel image
export const ROW_IMAGE_HEIGHT = 100;       // bidding sale-asset row thumbnails
